import { Link } from 'react-router-dom'

import { PageContainer } from '@/components/shared/page-container'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <PageContainer className="py-16">
      <h1 className="text-3xl font-semibold">Seite nicht gefunden</h1>
      <p className="mt-2 text-muted-foreground">Der aufgerufene Pfad existiert nicht.</p>
      <Button asChild className="mt-6">
        <Link to="/">Zur Startseite</Link>
      </Button>
    </PageContainer>
  )
}
